'use strict';

const axios = require('axios');
const moment = require('moment');
const config = require('../config');

const INVITE_TOKEN_URL = config.apiUrl + `/AppUsers/inviteToken`;

module.exports = function getInviteToken(token) {
    return axios({
        method: 'get',
        url: INVITE_TOKEN_URL,
        params: {token}
    }).then(result => {
        const expiresAt = result.data.expiresAt;
        const isExpired = moment().isAfter(moment(expiresAt));
        return new Promise((resolve, reject) => {
            if (!isExpired && result.data.valid) {
                resolve(result.data);
            } else {
                reject('Your invitation has expired. Please request ' +
                    'a new invitation email from your employer.');
            }
        });
    });
};



// WEBPACK FOOTER //
// ./app/helpers/getInviteToken.js